import React, { useState } from "react";
import CuDropdown from "../../common_component/component/CuDropdown";
import InputField from "../../common_component/component/InputField";
import CuButton from "../../all-patient/components/CuButton";
import { IoAddSharp } from "react-icons/io5";
import { IoIosAttach } from "react-icons/io";
import CustomButton from "../../common_component/component/CustomButton";

const AddHistory = () => {
  const [searchCategory, setSearchCategory] = useState("");
  const [addHistory, setAddHistory] = useState("");
  const [note, setNote] = useState("");
  const [healthCondition, setHealthCondition] = useState("");
  const [date1, setDate1] = useState("");
  const [date2, setDate2] = useState("");

  const handleSearchCategoryChange = (e) => {
    setSearchCategory(e.target.value);
  };

  const handleAddHistoryChange = (e) => {
    setAddHistory(e.target.value);
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const handleHealthConditionChange = (e) => {
    setHealthCondition(e.target.value);
  };

  const handleDate1Change = (e) => {
    setDate1(e.target.value);
  };

  const handleDate2Change = (e) => {
    setDate2(e.target.value);
  };

  const handleSubmit = () => {
    // You can implement the save functionality here
    // For now, let's just log the values
    //("Search Category:", searchCategory);
    //("Add History:", addHistory);
    //("Note:", note);
    //("Health Condition:", healthCondition);
    //("Date 1:", date1);
    //("Date 2:", date2);
  };

  return (
    <div className="border w-90% p-6">
      <div>
        <h3>Patient Name: </h3>
      </div>

      <div className="mt-12">
        <h4>Add History by Category </h4>
        <div className="flex items-center gap-5 flex-wrap">
          <div className="w-96">
            <label>Search Category</label>
            <CuDropdown
              placeholder="Search"
              value={searchCategory}
              onChange={handleSearchCategoryChange}
            />
          </div>

          <div>
            <label>Date</label>
            <InputField
              type={"date"}
              value={date1}
              onChange={handleDate1Change}
            />
          </div>

          <div className="mt-auto">
            <CuButton
              className={
                "bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-3 px-4 rounded inline-flex items-center"
              }
            >
              <IoAddSharp />
              <span>Add Date</span>
            </CuButton>
          </div>
          <div>
            <label>Add History</label>
            <textarea
              className="block w-96 border rounded-sm p-2"
              placeholder="Type here"
              value={addHistory}
              onChange={handleAddHistoryChange}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="mt-12">
        <h4>Add History by Document </h4>
        <div className="flex items-center gap-5 flex-wrap">
          <div className="w-96">
            <label>Add Note</label>
            <textarea
              className="block w-96 border rounded-sm p-0"
              placeholder="Type here"
              value={note}
              onChange={handleNoteChange}
            ></textarea>
          </div>

          <div>
            <label>Date</label>
            <InputField
              type={"date"}
              value={date2}
              onChange={handleDate2Change}
            />
          </div>

          <div className="mt-auto">
            <label>Expiry Optional</label>
            <InputField type={"date"} />
          </div>
          <div className="flex items-center gap-2 cursor-pointer">
            <IoIosAttach color="#17A1FA" />
            <label className="text-[#17A1FA]">Attach File</label>
          </div>
        </div>
      </div>

      <div className="mt-12">
        <h4>Add Health Condition </h4>
        <div className="flex items-center gap-5 flex-wrap">
          <div className="w-96">
            <label>Add Health Condition</label>
            <textarea
              className="block w-96 border rounded-sm p-0"
              placeholder="Type here"
              value={healthCondition}
              onChange={handleHealthConditionChange}
            ></textarea>
          </div>

          <div>
            <label>Date</label>
            <InputField type={"date"} />
          </div>
        </div>
      </div>

      <div className="flex gap-6 mt-8">
        <CuButton
          className={
            "bg-white border w-1/5 text-gray-800 font-bold py-3 px-6 rounded items-center"
          }
        >
          Cancel
        </CuButton>
        <CuButton
          className={
            "bg-[#EBF8EC] border w-1/5 text-gray-800 font-bold py-4 px-6 rounded items-center"
          }
          onClick={handleSubmit}
        >
          Save
        </CuButton>
      </div>
    </div>
  );
};

export default AddHistory;
